import React, { useState, useEffect, useContext, useRef } from "react";
import SubHeader from "./SubHeader";
import {
  FormGroup,
  Col,
  Label,
  Input,
  Form,
  Row,
  NavLink,
  ListInlineItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FaChevronDown, FaChevronRight, FaEdit, FaTimes,FaRedo } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
import axios from "../../api/axios";
import { GlobalContext } from "../../App";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import projectPlaceholderImg from "../../assets/images/no-projects.png";
import HoverTooltip from "../global/Tooltip";
import TopHeader from "./TopHeader";
import { InfinitySpin } from "react-loader-spinner";
function Task() {
  const navigate = useNavigate();
  const inputFile = useRef(null);
  const currentDate = new Date().toISOString().substr(0, 10);
  const body = document.body;
  const mainPanel = document.querySelector(".main-panel");
  const maskBgOverlay = document.createElement("div");
  maskBgOverlay.id = "maskBgOverlay";
  maskBgOverlay.className = "maskBgOverlay";
  const location = useLocation();
  const { pathname } = location;
  const { rolexModuleData, user_id, serialSequence, roles, userProfile } =
    useContext(GlobalContext);   
const isSpecialAccess = rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? true : false;

  const params = new URLSearchParams(location?.search);
  var param1 = params?.get("param1")
    ? parseInt(atob(params?.get("param1")))
    : null;
  var param2 = params?.get("?param2")
    ? parseInt(atob(params?.get("?param2")))
    : null;
  var status = params.get("status") ? atob(params.get("status")) : "All";
  // ................. expand collaspe product table...............................//
  const [productisOpen1, productsetIsOpen1] = useState(1);
  const [milestoneList, setMilestoneList] = useState([]);
  const [newMilestoneList, setNewMilestoneList] = useState([]);
  const [tempMilestoneList, setTempMilestoneList] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [tempTaskList, setTempTaskList] = useState([]);
  const [milestoneTitleList, setMilestoneTitleList] = useState([]);

  const [projectList, setProjectList] = useState([]);
  const [tempProjectList, setTempProjectList] = useState([]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [userDataList, setUserDataList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [userStatus, setUserStatus] = useState(status);
  const [taskData, setTaskData] = useState({
    projectTitle: [],
    milestoneTitle: [],
    taskTitle: "",
    taskDesc: "",
    taskStatus: { value: "Pipeline", label: "Pipeline" },
    TaskPrirority: { value: "High", label: "High" },
    TaskCompletionDate: "",
    taskStartDate: "",
    taskEndDate: "",
    taskOwner: [],
    updateId: null,
    taskCompletionPercentage: { value: "0", label: "0" },
    taskUATSignOffForm: "",
  });
  const [loading, setLoading] = useState(true);
  const [filterTask, setFilterTask] = useState({
    taskId: "",
    taskTitle: "",
    projectTitle:"",
    milestoneTitle:"",
    taskStartDate: "",
    taskEndDate: "",
    createdBy: "",
  });
  const [taskProjectList, setTaskProjectList] = useState([]);
  //................... End  expand collaspe product table..........................//

  // Handle Error
  const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
  // ------------------------------------------------------------- Get Milestone List ---------------------------------
  const getMilestoneList = (milestoneList) => {
    setLoading(true);
    axios
      .post("/getMilestoneList")
      .then((response) => {
        const milestone = response?.data?.[0]?.milestone_data?.filter((data) =>
        isSpecialAccess ||
          data?.project_master?.[0]?.project_owner_id === user_id ||
          parseInt(data?.createdBy) === user_id
            ? data
            : milestoneList?.includes(data?.milestone_id)
        );
        setMilestoneList(milestone);
        setNewMilestoneList(milestone);
        setTempMilestoneList(milestone);
        setLoading(false);
      })
      .catch(handleError);
  };
  // -------------------------------------------------------- Get Project List --------------------------------------

  const getProjectList = (projectList) => {
    setLoading(true);
    axios
      .get("/getProjectList")
      .then((response) => {
        const ProjectList =
          response?.data?.[0]?.project_data
            ?.filter(
              (data) =>
                (param1
                  ? data?.project_id === param1
                  : isSpecialAccess ||
                    data?.project_owner_id === user_id ||
                    parseInt(data?.createdBy) === user_id
                  ? data
                  : projectList?.includes(data?.project_id)) &&
                !(
                  data?.project_status === "Completed" ||
                  data?.project_status === "Cancelled" ||
                  data?.project_status === "On Hold"
                )
            )
            ?.map((item) => ({
              label: item?.project_title,
              value: item?.project_id,
              projectOwner: item?.project_x_owner,
              startDate: item?.start_date,
              endDate: item?.end_date,
              projectStatus: item?.project_status,
            })) ?? [];
        setProjectList(ProjectList);
        setTempProjectList(response?.data?.[0]?.project_data);
        setLoading(false);
      })
      .catch(handleError);
  };
  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    setLoading(true);
    const UserListCriteria = isSpecialAccess
      ? ""
      : userProfile || "";
    axios
      .get(`/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`)
      .then((response, error) => {
        const userList = response?.data?.[0]?.user_data
          ?.filter((item) => item?.user_id === user_id)?.[0]
          ?.user_x_milestone?.filter((data) => data?.milestone_access === 1 || data?.createdBy === user_id)
          ?.map((data) => data?.milestone_id);
        const userTaskList = response?.data?.[0]?.user_data
          ?.filter((item) => item?.user_id === user_id)?.[0]
          ?.user_x_task?.filter((data) => data?.task_access === 1 || data?.createdBy === user_id)
          ?.map((data) => data?.task_id);
        const userProjectList = userList
          ?.filter((data) => data?.project_access === 1 || data?.createdBy === user_id)
          ?.map((data) => data?.project_id);
        getMilestoneList(userList);
        getProjectList(userProjectList);
        getTaskList(userTaskList);
        setLoading(false);
      })
      .catch(handleError);
  };

  const UserDataList = (select) => {
    setTaskData({
      ...taskData,
      milestoneTitle: select,
      taskStatus: { value: "Pipeline", label: "Pipeline" },
      TaskPrirority: { value: "High", label: "High" },
      TaskCompletionDate: "",
      taskStartDate: "",
      taskEndDate: "",
      taskOwner: [],
      taskCompletionPercentage: { value: "0", label: "0" },
      taskUATSignOffForm: "",
    });
    const userDataList =
      select?.milestoneOwner?.map((item) => ({
        label: item?.user_data?.[0]?.name,
        value: item?.user_id,
        email: item?.user_data?.[0]?.email_id,
      })) ?? [];
    setUserDataList(userDataList);
  };
  // ---------------------------------------------------------- Status List --------------------------------------
  const taskStatusList = [
    { value: "Pipeline", label: "Pipeline", percentage: "0" },
    { value: "In Progress", label: "In Progress", percentage: "10" },
    { value: "Analysis", label: "Analysis", percentage: "20" },
    { value: "Design", label: "Design", percentage: "30" },
    { value: "Development", label: "Development", percentage: "40" },
    { value: "UAT", label: "UAT", percentage: "80" },
    { value: "Completed", label: "Go Live", percentage: "100" },
    { value: "Cancelled", label: "Cancelled" },
    { value: "On Hold", label: "On Hold" },
  ];
  // ------------------------------------------------------------ Priority List -------------------------------------
  const taskPriorityList = [
    { value: "High", label: "High" },
    { value: "Moderate", label: "Moderate" },
    { value: "Low", label: "Low" },
  ];
  // ------------------------------------------------------------- Milestone Title List ------------------------------

  const getMilestoneTitleList = (select) => {
    setTaskData({
      ...taskData,
      projectTitle: select,
      milestoneTitle: [],
      taskStatus: { value: "Pipeline", label: "Pipeline" },
      TaskPrirority: { value: "High", label: "High" },
      TaskCompletionDate: "",
      taskStartDate: "",
      taskEndDate: "",
      taskOwner: [],
      taskCompletionPercentage: { value: "0", label: "0" },
      taskUATSignOffForm: "",
    });
    const milestoneTitleList =
      milestoneList
        ?.filter(
          (item) =>
            item?.project_id === select?.value &&
            (param2 ? item?.milestone_id === param2 : item) &&
            !(
              item?.milestone_status === "Completed" ||
              item?.milestone_status === "Cancelled" ||
              item?.milestone_status === "On Hold"
            )
        )
        ?.map((item) => ({
          label: item?.milestone_title,
          value: item?.milestone_id,
          milestoneOwner: item?.milestone_x_owner,
          startDate: item?.milestone_start_date,
          endDate: item?.milestone_end_date,
          milestoneStatus: item?.milestone_status,
        })) ?? [];
    const userProjectList =
      select?.projectOwner?.map((item) => ({
        label: item?.user_data?.[0]?.name,
        value: item?.user_id,
        email: item?.user_data?.[0]?.email_id,
      })) ?? [];
    setUserDataList(userProjectList);
    setMilestoneTitleList(milestoneTitleList);
  };
  // ------------------------------------------------------- Add Task --------------------------------------------
  const postAddTask = (e) => {
    const allowedFilenameRegex = /^[a-zA-Z0-9_\-\.]+$/;
    if (taskData?.projectTitle?.length <= 0) {
      e.preventDefault();
      toast.error("Project title is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
    //  else if (taskData?.milestoneTitle?.length <= 0) {
    //   e.preventDefault();
    //   toast.error("Milestone title is required!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000,
    //   });
    // }
    else if (taskData?.taskTitle === null || taskData?.taskTitle === "") {
      e.preventDefault();
      toast.error("Task Title is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (taskData?.taskOwner?.length <= 0) {
      e.preventDefault();
      toast.error("Please select team member!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
    // else if (!taskData?.taskOwnerId?.value) {
    //   e.preventDefault();
    //   toast.error("Please select owner first!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000
    //   });
    // }
    // else if (!taskData?.taskOwner?.some(owner => owner.value === taskData?.taskOwnerId?.value)) {
    //   e.preventDefault();
    //   toast.error("Please select Owner in team members!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000
    //   });
    // }
    else if (taskData?.taskDesc === null || taskData?.taskDesc === "") {
      e.preventDefault();
      toast.error("Description is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      (taskData?.taskStartDate === null || taskData?.taskStartDate === "") &&
      taskData?.taskStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error("Start date is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      (taskData?.taskEndDate === null || taskData?.taskEndDate === "") &&
      taskData?.taskStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error("End date is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      taskData?.taskStartDate > taskData?.taskEndDate &&
      taskData?.taskStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error("Task end date cannot be greater than start date!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      taskData?.taskStartDate < taskData?.projectTitle?.startDate &&
      taskData?.taskStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error(
        `Task start date should be greater than or equal to project start date! ${taskData?.projectTitle?.startDate}`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else if (
      taskData?.taskEndDate > taskData?.projectTitle?.endDate &&
      taskData?.taskStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error(
        `Task end date should be less than or equal to project end date! ${taskData?.projectTitle?.endDate}`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else if (
      taskData?.taskStartDate < taskData?.milestoneTitle?.startDate &&
      taskData?.taskStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error(
        `Task start date should be greater than or equal to milestone start date! ${taskData?.milestoneTitle?.startDate}`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else if (
      taskData?.taskEndDate > taskData?.milestoneTitle?.endDate &&
      taskData?.taskStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error(
        `Task end date should be less than or equal to milestone end date! ${taskData?.milestoneTitle?.endDate}`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else if (
      !file &&
      !taskData?.taskUATSignOffForm &&
      taskData?.taskStatus?.value === "Completed"
    ) {
      e.preventDefault();
      toast.error(`Please Upload Task UAT Form First`, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
     else if ( file && !allowedFilenameRegex.test(file?.name)) {
        toast.error("UAT Sign-Off Form filename can only contain letters, numbers, underscores (_) and hyphens (-)", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        });
      } else {
      // if (
      //   !taskData?.taskOwner?.some((member) => member.value === user_id) &&
      //   !roles?.find((data) => data?.role_id === 1001)
      // ) {
      //   e.preventDefault();
      //   taskData?.taskOwner?.push({
      //     label: userProfile?.name,
      //     value: user_id,
      //     email: userProfile?.emailId,
      //   });
      // }
      // const params = {
      //   taskData: taskData,
      //   user_id: user_id,
      //   taskId: serialSequence[3]?.project_seqence,
      //   userProfile: userProfile,
      // };
      let formData = new FormData();
      formData.append("task_UAT_doc", file);
      formData.append("user_id", user_id);
      formData.append("taskId", serialSequence[3]?.project_seqence);
      formData.append("taskData", JSON?.stringify(taskData));
      formData.append("userProfile", JSON?.stringify(userProfile));
      axios
        .post("/postAddTask", formData)
        .then((response) => {
          if (response.status === 202) {
            e.preventDefault();
            toast.error("Task already exist!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else {
            toast.success(
              `Task ${
                taskData?.updateId != null ? "updated" : "created"
              } successfully!`,
              {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000,
              }
            );
            handleClose();
            getUserData();
          }
        })
        .catch(handleError);
    }
  };
  // ------------------------------------------------------------- Get Task List ---------------------------------

  const getTaskList = (userTaskList) => {
    setLoading(true);
  
    axios
      .post("/getTaskList")
      .then((response) => {
        const taskData = response?.data?.[0]?.task_data;
        if (!taskData) {
          setLoading(false);
          return;
        }
  
        // Create a map to store unique projects and milestones
        const projectMap = new Map();
        const milestoneMap = new Map();
  
        const formattedTaskList = taskData
          ?.sort((a, b) => (a.updatedDate < b.updatedDate ? 1 : -1))
          ?.filter((data) => param2 ? param2 === data?.milestone_id : param1 ? param1 === data?.project_id : 
          isSpecialAccess ||
            data?.project_master?.[0]?.project_owner_id === user_id ||
            parseInt(data?.createdBy) === user_id
              ? data
              : userTaskList?.includes(data?.task_id)
          )
          ?.map((task) => {
            const projectId = task?.project_master?.[0]?.project_id;
            const milestoneId = task?.milestone_master?.[0]?.milestone_id;
  
            // Add project to the map if not present
            if (projectId && !projectMap.has(projectId)) {
              projectMap.set(projectId, task.project_master[0]);
            }
  
            // Add milestone to the map if not present
            if (milestoneId && !milestoneMap.has(milestoneId)) {
              milestoneMap.set(milestoneId, task.milestone_master[0]);
            }
  
            return {
              ...task,
              project: projectMap.get(projectId),
              milestone: milestoneMap.get(milestoneId),
            };
          });
        const groupedTaskData = {};
        formattedTaskList?.forEach((task) => {
          const projectId = task?.project?.project_id;
          const milestoneId = task?.milestone?.milestone_id ;
          if (projectId || milestoneId) {
            const key = `${projectId}_${milestoneId}`;
  
            if (!groupedTaskData[key]) {
              groupedTaskData[key] = {
                projectTitle: task?.project?.project_title || "",
                projectId: projectId,
                milestoneTitle: task?.milestone?.milestone_title || "",
                milestoneId: milestoneId,
                taskData: [],
              };
            }
  
            groupedTaskData[key].taskData.push(task);
          }
        });
    
        // Convert the grouped task data object to an array
        const TaskProjectList = Object.values(groupedTaskData);
        setTaskProjectList(TaskProjectList);
        productsetIsOpen1(formattedTaskList?.[0]?.task_id);
        setTaskList(formattedTaskList);
        setTempTaskList(TaskProjectList);
        setLoading(false);
      })
      .catch(handleError);
  };
  // -------------------------------------------------------------- Update Task List --------------------------------
  const UptTask = (task_id, project_title, milestone_title) => {
    setModal(!modal);
    for (let i = 0; i < taskList?.length; i++) {
      if (taskList[i]?.task_id === task_id) {
        const OwnerList =
          taskList[i]?.task_x_owner?.map((item) => ({
            label: item?.user_data?.[0]?.name,
            value: item?.user_id,
          })) ?? [];
        setTaskData({
          projectTitle: {
            label: project_title,
            value: taskList[i]?.project_id,
            projectStatus: taskList[i]?.project_master?.[0]?.project_status,
            startDate: taskList[i]?.project_master?.[0]?.start_date,
            endDate:  taskList[i]?.project_master?.[0]?.end_date
          },
          milestoneTitle: {
            label: milestone_title,
            value: taskList[i]?.milestone_id,
            milestoneStatus:
              taskList[i]?.milestone_master?.[0]?.milestone_status,
            startDate: taskList[i]?.milestone_master?.[0]?.milestone_start_date,
            endDate:  taskList[i]?.milestone_master?.[0]?.milestone_end_date
          },
          taskTitle: taskList[i]?.task_title,
          taskDesc: taskList[i]?.task_desc,
          taskStatus: {
            value: taskList[i]?.task_status,
            label: taskList[i]?.task_status,
          },
          TaskPrirority: {
            value: taskList[i]?.task_priority,
            label: taskList[i]?.task_priority,
          },
          TaskCompletionDate: taskList[i]?.task_completion_date,
          taskStartDate: taskList[i]?.task_start_date,
          taskEndDate: taskList[i]?.task_end_date,
          taskOwner: OwnerList,
          updateId: taskList[i]?.task_id,
          taskCompletionPercentage: {
            value: taskList[i]?.task_completion_percentage,
            label: taskList[i]?.task_completion_percentage,
          },
          taskUATSignOffForm: taskList[i]?.task_uat_signoff_form,
        });
        for (let j = 0; j < milestoneList?.length; j++) {
          if (milestoneList[j]?.milestone_id === taskList[i]?.milestone_id) {
            const userDataList =
              milestoneList[j]?.milestone_x_owner
                ?.filter((item) => item?.isActive === "1")
                ?.map((item) => ({
                  label: item?.user_data?.[0]?.name,
                  value: item?.user_id,
                })) ?? [];
            setUserDataList(userDataList);
          }
        }
      }
    }
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };
  // ----------------------------------------------------------- Handle Close ---------------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    setTaskData({
      projectTitle: [],
      milestoneTitle: [],
      taskTitle: "",
      taskDesc: "",
      taskStatus: { value: "Pipeline", label: "Pipeline" },
      TaskPrirority: { value: "High", label: "High" },
      TaskCompletionDate: "",
      taskStartDate: "",
      taskEndDate: "",
      taskOwner: [],
      updateId: null,
      taskCompletionPercentage: { value: "0", label: "0" },
      taskUATSignOffForm: "",
      // taskOwnerId:[]
    });
    body.style.overflow = "";
    document.getElementById("maskBgOverlay").remove();
  };

  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };

  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };

  // -------------------------------------------------------- Filter Task List --------------------------------------
  // const filterTaskList = (clear) => {
  //   const filterTasks = tempTaskList?.filter(
  //     (data) =>
  //       (!filterTask?.milestoneTitle ||
  //         data?.milestoneTitle?.includes(
  //           filterTask.milestoneTitle
  //         ))
  //   )?.map((item)=>(
  //     item?.taskData?.filter((data)=>(
  //       (!filterTask?.taskId ||
  //         data?.find((item)=>item?.task_code?.includes(filterTask.taskId)) ||
  //         data?.find((item)=>item?.task_title?.includes(filterTask.taskId))) &&
  //       (!filterTask?.taskStartDate ||
  //         data?.find((item)=>item?.task_start_date?.includes(filterTask.taskStartDate))) &&
  //       (!filterTask?.taskEndDate ||
  //         data?.find((item)=>item?.task_end_date?.includes(filterTask.taskEndDate))) &&
  //       (!filterTask?.createdBy ||
  //         data?.find((item)=>item?.created_user?.includes(filterTask.createdBy)))
  //     ))
  //   ))
  //   setTaskProjectList(filterTasks);

  //   if (clear) {
  //     handleClose();
  //   }
  // };

  const filterTaskList = (clear) => {
    const filteredTasks = tempTaskList?.filter((data) => {
      return (
        (!filterTask?.projectTitle ||
          data?.projectTitle?.includes(filterTask.projectTitle)) &&
        (!filterTask?.milestoneTitle ||
          data?.milestoneTitle?.includes(filterTask.milestoneTitle)) 
          // &&
        // (!filterTask?.taskId ||
        //   data?.taskData?.some((item) =>
        //     item?.find(
        //       (task) =>
        //         task?.task_code?.includes(filterTask.taskId) ||
        //         task?.task_title?.includes(filterTask.taskId)
        //     )
        //   )) &&
        // (!filterTask?.taskStartDate ||
        //   data?.taskData?.some((item) =>
        //     item?.find((task) =>
        //       task?.task_start_date?.includes(filterTask.taskStartDate)
        //     )
        //   )) &&
        // (!filterTask?.taskEndDate ||
        //   data?.taskData?.some((item) =>
        //     item?.find((task) =>
        //       task?.task_end_date?.includes(filterTask.taskEndDate)
        //     )
        //   )) &&
        // (!filterTask?.createdBy ||
        //   data?.taskData?.some((item) =>
        //     item?.find((task) => task?.created_user?.includes(filterTask.createdBy))
        //   ))
      );
    });
  
    setTaskProjectList(filteredTasks);
  
    if (clear) {
      handleClose();
    }
  };
  

  // ------------------------------------------------------- Clear Filter Field ------------------------------------------
  const ClearFilter = () => {
    setFilterTask({
      taskId: "",
      taskTitle: "",
      projectTitle:"",
      milestoneTitle: "",
      taskStartDate: "",
      taskEndDate: "",
      createdBy: "",
    });
    filterTaskList(false);
    setNewMilestoneList(tempMilestoneList);
    setTaskProjectList(tempTaskList);
  };
  // ---------------------------------------------------------- Mantain Log History ------------------------------
  const postLogHistory = () => {
    const param = {
      user_id: user_id,
      module_name: "Task",
      operationPerformed: "navigate to task screen",
    };
    axios.post("/postLogHistory", param);
  };
  // ------------------------------------------------------------ Choose Document -----------------------------------
  const [file, setFile] = useState("");
  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files?.[0]);
    }
  };
  // ----------------------------------------------------------------- Document Select ---------------------------------

  const onButtonClick = () => {
    inputFile.current.click();
  };

  const FileManage = () => {
    setFile();
    setTaskData({ ...taskData, taskUATSignOffForm: "" });
  };
  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getUserData();
    // postLogHistory();
  }, []);
  return loading ? (
    <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
  ) : (
    <>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => navigate("/project-detail")}
                className="nav-link"
              >
                Projects <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <a onClick={() => navigate("/milestones")} className="nav-link">
                Milestones <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Tasks</span>
            </li>
          </>
        }
      />
      <SubHeader
        SubHeaderTitle="Status"
        ShowFilterIcon={true}
        openSidebar={modal}
        isFilter={isFilter}
        handleClose={handleClose}
        toggleModal={toggleModal}
        toggleFilter={toggleFilter}
        handleSubmit={postAddTask}
        filterSubmit={filterTaskList}
        titleButton={`${taskData?.updateId ? "Edit" : "Add"} Task`}
        showButton={
          rolexModuleData?.find(
            (data) => pathname === data?.description && data?.create === 1
          ) || roles?.find((data) => data?.role_id === 1001)
            ? true
            : false
        }
        AddUserContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectTitle">Project *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="single-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={taskData?.projectTitle}
                      onChange={(select) => getMilestoneTitleList(select)}
                      options={projectList}
                      // isMulti
                      // {...props}
                      isDisabled={taskData?.updateId ? true : false}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                {(milestoneTitleList?.length > 0 || taskData?.milestoneTitle?.value) && (
                  <Col md={12}>
                    <FormGroup>
                      <Label htmlFor="projectTitle">Milestone </Label>
                      <Select
                        classNamePrefix="react-select"
                        className="single-select"
                        menuPlacement="auto"
                        maxMenuHeight={200}
                        value={taskData?.milestoneTitle}
                        onChange={(select) => UserDataList(select)}
                        options={milestoneTitleList}
                        // isMulti
                        // {...props}
                        isDisabled={
                          taskData?.updateId ||
                          taskData?.projectTitle?.projectStatus ===
                            "Completed" ||
                          taskData?.projectTitle?.projectStatus === "Cancelled"
                            ? true
                            : false
                        }
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "rgba(2, 137, 255,.2)",
                            primary50: "rgba(2, 137, 255,.2)",
                            primary75: "rgba(2, 137, 255,.2)",
                            primary: "#0289ff",
                          },
                        })}
                      />
                    </FormGroup>
                  </Col>
                )}

                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="taskTitle">Task Title *</Label>
                    <Input
                      type="text"
                      id="taskTitle"
                      name="taskTitle"
                      value={taskData?.taskTitle || ""}
                      onChange={(e) =>
                        setTaskData({ ...taskData, taskTitle: e.target.value })
                      }
                      disabled={
                        taskData?.projectTitle?.projectStatus === "Completed" ||
                        taskData?.projectTitle?.projectStatus === "Cancelled" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Completed" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Cancelled"
                          ? true
                          : false
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="taskOwner">Team Members *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      value={taskData?.taskOwner}
                      onChange={(select) =>
                        setTaskData({ ...taskData, taskOwner: select })
                      }
                      options={userDataList}
                      isDisabled={
                        taskData?.projectTitle?.projectStatus === "Completed" ||
                        taskData?.projectTitle?.projectStatus === "Cancelled" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Completed" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Cancelled"
                          ? true
                          : false
                      }
                      isMulti
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="taskDesc">Description*</Label>
                    <Input
                      type="textarea"
                      id="taskdetail"
                      value={taskData?.taskDesc || ""}
                      onChange={(e) =>
                        setTaskData({ ...taskData, taskDesc: e.target.value })
                      }
                      style={{ minHeight: "120px" }}
                      disabled={
                        taskData?.projectTitle?.projectStatus === "Completed" ||
                        taskData?.projectTitle?.projectStatus === "Cancelled" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Completed" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Cancelled"
                          ? true
                          : false
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor="taskStatus">Status*</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="single-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      value={taskData?.taskStatus}
                      // onChange={(select) => setTaskData({ ...taskData, taskStatus: select })}
                      onChange={(select) =>
                        setTaskData({
                          ...taskData,
                          taskStatus: select,
                          TaskCompletionDate:
                            taskData?.TaskCompletionDate === null ||
                            taskData?.TaskCompletionDate === ""
                              ? currentDate
                              : taskData?.TaskCompletionDate,
                          taskCompletionPercentage:
                            select?.value !== "Cancelled" &&
                            select?.value !== "On Hold"
                              ? {
                                  label: select?.percentage,
                                  value: select?.percentage,
                                }
                              : taskData?.taskCompletionPercentage,
                          taskUATSignOffForm: "",
                        })
                      }
                      options={taskStatusList}
                      isDisabled={
                        taskData?.projectTitle?.projectStatus === "Pipeline" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Pipeline" ||
                        taskData?.projectTitle?.projectStatus === "Completed" ||
                        taskData?.projectTitle?.projectStatus === "Cancelled" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Completed" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Cancelled"
                          ? true
                          : false
                      }
                      // isMulti
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor="TaskPrirority">Priority *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="single-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      value={taskData?.TaskPrirority}
                      onChange={(select) =>
                        setTaskData({ ...taskData, TaskPrirority: select })
                      }
                      options={taskPriorityList}
                      isDisabled={
                        taskData?.projectTitle?.projectStatus === "Completed" ||
                        taskData?.projectTitle?.projectStatus === "Cancelled" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Completed" ||
                        taskData?.milestoneTitle?.milestoneStatus ===
                          "Cancelled"
                          ? true
                          : false
                      }
                      // isMulti
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                {taskData?.taskStatus?.value === "Pipeline" ? null : (
                  <>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="taskStartDate">Start Date *</Label>
                        <Input
                          type="date"
                          id="taskStartDate"
                          name="taskStartDate"
                          min={
                            taskData?.milestoneTitle?.startDate ||
                            taskData?.projectTitle?.startDate ||
                            ""
                          }
                          max={
                            taskData?.milestoneTitle?.endDate ||
                            taskData?.projectTitle?.endDate ||
                            ""
                          }
                          value={taskData?.taskStartDate || ""}
                          onChange={(e) =>
                            setTaskData({
                              ...taskData,
                              taskStartDate: e.target.value,
                              taskEndDate: "",
                            })
                          }
                          disabled={
                            taskData?.projectTitle?.projectStatus ===
                              "Pipeline" ||
                            taskData?.milestoneTitle?.milestoneStatus ===
                              "Pipeline" ||
                            taskData?.projectTitle?.projectStatus ===
                              "Completed" ||
                            taskData?.projectTitle?.projectStatus ===
                              "Cancelled" ||
                            taskData?.milestoneTitle?.milestoneStatus ===
                              "Completed" ||
                            taskData?.milestoneTitle?.milestoneStatus ===
                              "Cancelled"
                              ? true
                              : false
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="taskEndDate">End Date *</Label>
                        <Input
                          type="date"
                          id="taskEndDate"
                          name="taskEndDate"
                          min={taskData?.taskStartDate || 
                            taskData?.milestoneTitle?.startDate ||
                            taskData?.projectTitle?.startDate  || ""}
                          max={
                            taskData?.milestoneTitle?.endDate ||
                            taskData?.projectTitle?.endDate ||
                            ""
                          }
                          value={taskData?.taskEndDate || ""}
                          onChange={(e) =>
                            setTaskData({
                              ...taskData,
                              taskEndDate: e.target.value,
                            })
                          }
                          disabled={
                            taskData?.projectTitle?.projectStatus ===
                              "Pipeline" ||
                            taskData?.milestoneTitle?.milestoneStatus ===
                              "Pipeline" ||
                            taskData?.projectTitle?.projectStatus ===
                              "Completed" ||
                            taskData?.projectTitle?.projectStatus ===
                              "Cancelled" ||
                            taskData?.milestoneTitle?.milestoneStatus ===
                              "Completed" ||
                            taskData?.milestoneTitle?.milestoneStatus ===
                              "Cancelled" ||
                              !taskData?.taskStartDate
                              ? true
                              : false
                          }
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
                {taskData?.taskStatus?.value === "Completed" && (
                  <Col md={12}>
                    <FormGroup>
                      <Label htmlFor="taskEndDate">UAT Sign Off Form *</Label>
                      {taskData?.taskUATSignOffForm ? (
                        <span style={{display:"flex",textDecoration:"underline",color:"#156cdb"}}>
                          {" "}
                          {taskData?.taskUATSignOffForm}{" "}
                          <NavLink
                            onClick={FileManage}
                            style={{
                              padding: "0",
                              lineHeight: "14px",
                              marginLeft: "6px",
                            }}
                          >
                            {" "}
                            <FaTimes className="svgicon" style={{margin:"4px 0"}} />{" "}
                          </NavLink>
                        </span>
                      ) : file ? (
                        <span
                          style={{
                            display: "flex",
                            textDecoration: "underline",
                            color: "#156cdb",
                          }}
                        >
                          {" "}
                          {file?.name}{" "}
                          <NavLink
                            onClick={FileManage}
                            style={{
                              padding: "0",
                              lineHeight: "14px",
                              marginLeft: "6px",
                            }}
                          >
                            {" "}
                            <FaTimes
                              className="svgicon"
                              style={{ margin: "4px 0" }}
                            />{" "}
                          </NavLink>{" "}
                        </span>
                      ) : (
                        <div
                          className="file-input"
                          onClick={() => {
                            onButtonClick();
                          }}
                        >
                          <span className="plus-icon">+</span>
                          <label className="button" for="myFile">
                            Browse File
                          </label>
                          <input
                            accept=".pdf"
                            id="task-document"
                            ref={inputFile}
                            onChange={onSelectFile}
                            name="document"
                            type="file"
                          />
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                )}
              </Row>
            </FormGroup>
          </Form>
        }
        userStatus={
          <ListInlineItem>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
              <DropdownToggle className="activeuser" caret>
                {userStatus}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => setUserStatus("Pipeline")}>
                  Pipeline
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("In Progress")}>
                  In Progress
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Analysis")}>
                  Analysis
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Design")}>
                  Design
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Development")}>
                  Development
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("UAT")}>
                  UAT
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Completed")}>
                  Go Live
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Cancelled")}>
                  Cancelled
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("On Hold")}>
                  On Hold
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("All")}>
                  All
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </ListInlineItem>
        }
        SlideBarContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <div className="resetFilterOption">
                    <a onClick={ClearFilter}>Clear Filter</a>
                  </div>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="ProjectTitle">Project Title</Label>
                    <Input
                      type="text"
                      id="ProjectTitle"
                      name="ProjectTitle"
                      value={filterTask?.projectTitle || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          projectTitle: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="MilestoneTitle">Milestone Title</Label>
                    <Input
                      type="text"
                      id="MilestoneTitle"
                      name="MilestoneTitle"
                      value={filterTask?.milestoneTitle || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          milestoneTitle: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                {/* <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="taskId">Task ID/Title</Label>
                    <Input
                      type="text"
                      placeholder="Search by Task ID or Title"
                      id="taskId"
                      name="taskId"
                      value={filterTask?.taskId || ""}
                      onChange={(e) =>
                        setFilterTask({ ...filterTask, taskId: e.target.value })
                      }
                      disabled={
                        filterTask?.taskTitle?.length > 0 ? true : false
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="startDate">Start Date</Label>
                    <Input
                      type="date"
                      id="startDate"
                      name="startDate"
                      value={filterTask?.taskStartDate || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          taskStartDate: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="endDate">End Date</Label>
                    <Input
                      type="date"
                      id="endDate"
                      name="endDate"
                      value={filterTask?.taskEndDate || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          taskEndDate: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Created By</Label>
                    <Input
                      type="text"
                      id="createdBy"
                      name="createdBy"
                      value={filterTask?.createdBy || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          createdBy: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col> */}
              </Row>
            </FormGroup>
          </Form>
        }
      />
      <div id="tasks" className="contentInnerWrap">
        <div className="tasks-wrap">
          <div className="dropdown-wrap">
          {/* <div className="reloadData">
            <FaRedo onClick={getUserData} title="Refresh Data" />
          </div> */}
            {taskProjectList?.length > 0 ?  
            ( taskProjectList?.filter((item)=> item?.taskData?.find((item)=> userStatus === "All" ? item : item?.task_status === userStatus))?.length > 0 ?
              (taskProjectList?.filter((item)=> item?.taskData?.find((item)=> userStatus === "All" ? item : item?.task_status === userStatus))?.map((data) => (
                  <>
                    <div className="dropdown " onClick={()=> productsetIsOpen1(productisOpen1 === data?.taskData?.[0]?.task_id ? 0 : data?.taskData?.[0]?.task_id)}>
                        {productisOpen1 === data?.taskData?.[0]?.task_id ? (
                          <FaChevronDown />
                        ) : (
                          <FaChevronRight
                          />
                        )}
                        <span>
                          <a onClick={() => navigate(`/project-detail?param1=${btoa(data?.projectId)}`)}>
                            {data?.projectTitle}
                          </a>
                          {data?.milestoneTitle?.length > 0 && (
                            <a onClick={() => navigate(`/milestones?param1=${btoa( data?.projectId )}&?param2=${btoa(data?.milestoneId)}`)}>
                              <BsChevronRight />
                              {data?.milestoneTitle}
                            </a>
                          )}
                        </span>
                      </div>
                    <div className="product-table">
                      <div
                        className={
                          productisOpen1 === data?.taskData?.[0]?.task_id
                            ? "product-list  productlist-open"
                            : "product-list "
                        }
                      >
                        {data?.taskData?.filter(
                          (data1) =>
                            (userStatus === "All"
                              ? data1
                              : data1?.task_status === userStatus)
                        )?.length > 0 ? (
                          <MDBTable align="middle" className="projectTable">
                            <MDBTableHead>
                              <tr>
                                <th scope="col" style={{ minWidth: "420px" }}>
                                  Tasks
                                </th>
                                <th scope="col">Status</th>
                                <th
                                  scope="col"
                                  style={{
                                    minWidth: "220px",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  Team Members
                                </th>
                                <th scope="col">Task Completed</th>
                                <th scope="col">Duration</th>
                                <th scope="col">Start Date</th>
                                <th scope="col">End Date</th>
                                <th scope="col">Priority</th>
                                <th scope="col">Completion Date</th>
                                <th scope="col">UAT Sign OFF Form</th>
                                <th scope="col">Created On</th>
                                <th scope="col">Created By</th>
                                <th scope="col">Modified On</th>
                                <th scope="col">Modified By</th>
                                <th scope="col">Action</th>
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                              {data?.taskData?.filter(
                          (data1) =>
                            (userStatus === "All"
                              ? data1
                              : data1?.task_status === userStatus)
                        )?.map((data1) => (
                                  <tr className="table-light">
                                    <th scope="row">
                                      <span className="assignedId">
                                        {serialSequence[3]?.prefix}-
                                        {data1?.task_code}
                                      </span>{" "}
                                      <NavLink
                                        className="d-inline-block ps-2"
                                        onClick={() =>
                                          navigate(
                                            `/task-detail?param1=${btoa(
                                              data1?.task_id
                                            )}`
                                          )
                                        }
                                      >
                                        {data1?.task_title}
                                      </NavLink>{" "}
                                    </th>
                                    <td>
                                      <div
                                        className={
                                          "badge " +
                                          (data1?.task_status).replace(
                                            /\s/g,
                                            ""
                                          )
                                        }
                                      >
                                        {data1?.task_status === "Completed"
                                          ? "Go Live"
                                          : data1?.task_status}
                                      </div>
                                    </td>
                                    {/* <td scope="row">
                                  {data1?.task_owner&& data1?.task_owner?.[0]?.name || '-'}
                              </td> */}
                                    <HoverTooltip
                                      arrow
                                      title={
                                        data1?.task_x_owner?.length > 0
                                          ? data1?.task_x_owner
                                              .map((data) => data?.user_data?.[0]?.name)
                                              .sort((a, b) =>
                                                a.localeCompare(b)
                                              )
                                              .join(", ")
                                          : " - "
                                      }
                                    >
                                      {/* <td style={{ minWidth: '220px', whiteSpace: 'normal'}}>{data1?.task_x_owner?.length > 0 ? data1?.task_x_owner?.map((data) => data?.name).join(", ") : " - "}</td> */}
                                      <td
                                        style={{
                                          minWidth: "220px",
                                          maxWidth: "250px",
                                          webkitLineClamp: "3",
                                          webkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {data1?.task_x_owner?.length > 0
                                          ? data1?.task_x_owner
                                              .map((data) => data?.user_data?.[0]?.name)
                                              .sort((a, b) =>
                                                a.localeCompare(b)
                                              )
                                              .join(", ")
                                          : " - "}
                                      </td>
                                    </HoverTooltip>
                                    <td>
                                      <div className="progressBarWrap">
                                        <div
                                          className="progress"
                                          style={{ height: "15px" }}
                                        >
                                          <div
                                            className={`progress-bar bg-success`}
                                            role="progressbar"
                                            style={{
                                              width: `${data1?.task_completion_percentage}%`,
                                            }}
                                            aria-valuenow="25"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                          >
                                            &nbsp;
                                          </div>
                                          <div
                                            className={`percentageText ${
                                              data1?.task_completion_percentage >
                                              50
                                                ? "text-white"
                                                : ""
                                            }`}
                                          >
                                            {
                                              data1?.task_completion_percentage
                                            }
                                            %
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      {data1?.task_start_date?.length > 0
                                        ? Math.floor(
                                            (new Date(data1?.task_end_date) -
                                              new Date(
                                                data1?.task_start_date
                                              )) /
                                              (1000 * 60 * 60 * 24)
                                          ) + 1 || " 0 "
                                        : " 0 "}{" "}
                                      days
                                    </td>
                                    <td>
                                      {data1?.task_start_date?.length > 0
                                        ? new Date(
                                            data1?.task_start_date
                                          ).toLocaleDateString("en-TT")
                                        : " - "}
                                    </td>
                                    <td
                                      className={
                                        data1?.task_end_date < currentDate
                                          ? "dateExpired"
                                          : ""
                                      }
                                    >
                                      {data1?.task_end_date?.length > 0
                                        ? new Date(
                                            data1?.task_end_date
                                          ).toLocaleDateString("en-TT")
                                        : " - "}
                                    </td>
                                    <td>{data1?.task_priority}</td>
                                    <td>
                                      {data1?.task_status === "Completed"
                                        ? new Date(
                                            data1?.task_completion_date
                                          )?.toLocaleDateString("en-TT")
                                        : " -"}
                                    </td>
                                    <td>
                                      { data1?.task_uat_signoff_form ? (
                                        <NavLink
                                          style={{
                                            minWidth: "220px",
                                            maxWidth: "250px",
                                            webkitLineClamp: "3",
                                            webkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                          className="downloadicon"
                                          href={
                                            data1?.task_uat_signoff_form
                                          }
                                          target="_blank"
                                        >
                                         {data1?.task_uat_signoff_form?.split("/").pop()?.split("-").slice(1).join("-")}
                                        </NavLink>
                                      )  : "-"}
                                    </td>
                                    <td>
                                      {new Date(
                                        data1?.createdDate.split(" ")?.[0]
                                      ).toLocaleDateString("en-TT")}
                                    </td>
                                    <td>
                                      {data1?.created_user?.length > 0
                                        ? data1?.created_user?.[0]?.name
                                        : "-"}
                                    </td>
                                    <td>
                                      {new Date(
                                        data1?.updatedDate.split(" ")?.[0]
                                      ).toLocaleDateString("en-TT")}
                                    </td>
                                    <td>
                                      {data1?.updated_user?.length > 0
                                        ? data1?.updated_user?.[0]?.name
                                        : "-"}
                                    </td>
                                    {(rolexModuleData?.find(
                                      (data) =>
                                        pathname === data?.description &&
                                        data?.update === 1
                                    ) && data1?.task_status !== "Completed" ) ||
                                    roles?.find(
                                      (data) => data?.role_id === 1001
                                    ) ? (
                                      <td>
                                        <NavLink
                                          onClick={() =>
                                            UptTask(
                                              data1?.task_id,
                                              data?.projectTitle,
                                              data?.milestoneTitle
                                            )
                                          }
                                        >
                                          <FaEdit />{" "}
                                        </NavLink>
                                      </td>
                                    ) : <td>-</td>}
                                  </tr>
                                ))}
                            </MDBTableBody>
                          </MDBTable>
                        ) : (
                          // </Scrollbars>
                          <div className="defaultPlaceholder">
                            <img
                              src={projectPlaceholderImg}
                              alt="No Project"
                            />
                            <h4 className="defaultPlaceholderText">
                              There are no task under "{userStatus}" status!
                            </h4>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ))) :
                (
                  <div className="defaultPlaceholder">
                    <img src={projectPlaceholderImg} alt="No Project" />
                    <h4 className="defaultPlaceholderText">There are no task under "{userStatus}" status!</h4>
                  </div>
                )

            ) 
               : (
              <div className="defaultPlaceholder">
                <img src={projectPlaceholderImg} alt="No Project" />
                <h4 className="defaultPlaceholderText">There are no task!</h4>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Task;
